/* eslint-disable prefer-destructuring */
/* eslint-disable react/prop-types */
import Text from '../../../assets/styles/Text';
import GroupInput from '../../../components/GroupInput';
import * as styles from '../styles';

const GENDERS = [
  { key: 'WOMAN', label: 'Mulher', value: 'WOMAN' },
  { key: 'MAN', label: 'Homen', value: 'MAN' },
  { key: 'TRANSEX', label: 'Trans', value: 'TRANSEX' },
];

export default function BasicInfoSection({
  formData,
  updateFormField,
  cities,
  getErrorMessageByFieldName,
  removeError,
  setError,
}) {
  return (
    <styles.SectionContent>
      <Text.H1>DESCRIÇÃO BÁSICA </Text.H1>

      {/* Gênero */}
      <GroupInput select={Boolean(formData.sex)}>
        <label>Selecione seu sexo*</label>
        <select
          value={formData.sex}
          onChange={(e) => updateFormField('sex', e.target.value)}
        >
          <option value="" disabled>
            Escolha uma opção
          </option>
          {GENDERS.map(({ key, label }) => (
            <option key={key} value={key}>
              {label}
            </option>
          ))}
        </select>
      </GroupInput>

      {/* Nome Completo */}
      <GroupInput>
        <label>
          Nome completo* <span> - não será mostrado para terceiros</span>
        </label>
        <input
          type="text"
          placeholder="Digite seu nome completo*"
          value={formData.name}
          onChange={(e) => updateFormField('name', e.target.value)}
          maxLength={100}
        />
      </GroupInput>

      {/* Nome Fantasia */}
      <GroupInput>
        <label>Nome Fantasia*</label>
        <input
          type="text"
          placeholder="Digite seu nome fantasia"
          value={formData.nameFantasy}
          onChange={(e) => updateFormField('nameFantasy', e.target.value)}
          maxLength={50}
        />
      </GroupInput>

      {/* Data de Nascimento */}
      <GroupInput error={getErrorMessageByFieldName('date')}>
        <label>Data de nascimento*</label>
        <input
          type="date"
          value={formData.dateOfBirth}
          onChange={(e) => {
            updateFormField('dateOfBirth', e.target.value);
            removeError('date');
          }}
          max={new Date().toISOString().split('T')[0]}
        />
      </GroupInput>

      {/* Frase de Impacto */}
      <GroupInput error={getErrorMessageByFieldName('phrase')}>
        <label>
          Frase de impacto <span> - máximo de 80 caracteres</span>
        </label>
        <input
          type="text"
          placeholder="Digite uma frase de impacto"
          maxLength={80}
          value={formData.impactPhrase}
          onChange={(e) => {
            const value = e.target.value;
            if (value.length >= 80) {
              setError({
                field: 'phrase',
                message: 'A frase não pode ter mais de 80 caracteres',
              });
            } else {
              removeError('phrase');
              updateFormField('impactPhrase', value);
            }
          }}
        />
        <small>{formData.impactPhrase.length}/80 caracteres</small>
      </GroupInput>

      {/* Descrição */}
      <GroupInput>
        <label>Sobre você</label>
        <textarea
          placeholder="Digite sobre você"
          value={formData.description}
          onChange={(e) => updateFormField('description', e.target.value)}
          maxLength={500}
          rows={4}
        />
      </GroupInput>

      {/* Cidade */}
      <GroupInput select={Boolean(formData.selectedCity)}>
        <label>Sua cidade*</label>
        <select
          value={formData.selectedCity}
          onChange={(e) => updateFormField('selectedCity', e.target.value)}
        >
          <option value="" disabled>
            Escolha uma opção
          </option>
          {cities.map((city) => (
            <option value={city.id} key={city.id}>
              {city.name} - {city.stateAc}
            </option>
          ))}
        </select>
      </GroupInput>

      {/* Bairro */}
      <GroupInput>
        <label>Bairro</label>
        <input
          type="text"
          placeholder="Digite o bairro"
          value={formData.district}
          onChange={(e) => updateFormField('district', e.target.value)}
        />
      </GroupInput>
    </styles.SectionContent>
  );
}
